// Header text for the HR Skills Bridger sub-pages (Group / Employee, Skills Map
// / Skills Proficiency). Pure functions: the pages pass in what they already hold
// from router state.
//
// A "group" has no stored name. Group pages are only reachable with employees
// that share one job (SkillsBridgerV2.haveSelectedEmployeesSameJob), so the
// group is named after that shared role.

const MULTIPLE = "Multiple";

// Fields shown in the subtitle, in order. `keys` are tried in order because
// the table rows and older router state use different spellings.
const SUBTITLE_FIELDS = [
  { label: "Business Unit", keys: ["business_unit", "business"] },
  { label: "Function", keys: ["function"] },
  { label: "Sub-Function", keys: ["sub_function"] },
  { label: "Location", keys: ["location"] },
  { label: "Job Level", keys: ["job_level", "level"] },
];

const read = (record, keys) => {
  for (const key of keys) {
    const value = record?.[key];
    if (value !== undefined && value !== null && String(value).trim() !== "") return String(value).trim();
  }
  return "";
};

const describeField = (records, { label, keys }) => {
  const values = [...new Set(records.map((r) => read(r, keys)).filter(Boolean))];
  if (values.length === 0) return null;
  return `${label}: ${values.length === 1 ? values[0] : MULTIPLE}`;
};

export const buildGroupHeader = (selectedEmployees = []) => {
  const roleName = read(selectedEmployees[0], ["role_name"]);
  const count = selectedEmployees.length;
  const parts = [
    count > 0 ? `${count} ${count === 1 ? "employee" : "employees"}` : null,
    ...SUBTITLE_FIELDS.map((field) => describeField(selectedEmployees, field)),
  ].filter(Boolean);

  return {
    title: roleName ? `Group: ${roleName}` : "Group",
    subtitle: parts.join(", "),
  };
};

export const buildEmployeeHeader = (employee = {}) => {
  const name = read(employee, ["employee_name"]);
  const roleName = read(employee, ["role_name"]);
  const parts = [
    roleName ? `Role: ${roleName}` : null,
    ...SUBTITLE_FIELDS.map((field) => describeField([employee], field)),
  ].filter(Boolean);

  return {
    title: name ? `Employee: ${name}` : "Employee",
    subtitle: parts.join(", "),
  };
};
